export default __webpack_public_path__ + "static/media/banner-desktop-visiting-program.5bf5ba1a.webp";